import { writable } from 'svelte/store';
export const names = writable([]);
export const players = writable([]);
export const tacticsPlayers = writable([]);
export const countUpPlayers = writable([]);
export const beyondTopPlayers = writable([]);
export const shanghaiPlayers = writable([]);
export const dealADartPlayers = writable([]);
export const suddenDeathPlayers = writable([]);
export const killerPlayers = writable([]);
export const roundTheBoardPlayers = writable([]);
export const highLowPlayers = writable([]);
export const spinningWheelData = writable([]);
